import { newNotification } from "@kontextwerk/web-sdk/core/overlay/notifications"
import {
  confirmAppointment,
  type ScheduleEventConfirmResponse,
} from "../../../../../../../api/kehrblatt/schedule-events"
import { buildAppointmentDecisionNotification } from "./appointmentEmailNotice"

export type ExecuteSingleConfirmAppointmentOptions = {
  eventId: string
  sendConfirmationEmail: boolean
}

export const executeSingleConfirmAppointment = async ({
  eventId,
  sendConfirmationEmail,
}: ExecuteSingleConfirmAppointmentOptions): Promise<ScheduleEventConfirmResponse> => {
  const response = await confirmAppointment(eventId, {
    send_confirmation_email: sendConfirmationEmail,
  })
  const notice = buildAppointmentDecisionNotification("confirmed", response.email)
  newNotification(notice)

  return response
}

